import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
		padding      : "0.3rem 1rem",
		marginBottom : "0.5rem"
		// borderBottom : "1px solid #e7e7e7",

	},
	secondThirdFan: {
		// padding      : "0.5rem 1rem 0.8rem 0.5rem",
		marginBottom: "0.5rem"
	},
	fanContainer: {
		padding   : "2px 0",
		"&:after" : {
			content : "''",
			display : "block",
			margin  : "0 auto",
			width   : "50%"
			// padding : "3px"
		}
	},
	currenRankContainer: {
		padding : "1rem 0",
		zIndex  : 2
	},
	topSection: {
		display        : "flex",
		alignItems     : "center",
		padding        : "5px 0",
		justifyContent : "space-between"
	},
	currentTopSection: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "space-between"
	},
	avatarContainer: {
		flex: 0
	},
	nameContainer: {
		marginLeft : "1rem",
		"&:hover"  : {
			// textDecoration : "underline",
			color: theme.other.colors.text.primary
		}
	},
	avatar: {
		width  : "3.7rem",
		height : "3.7rem"
	},
	img: {
		height : "100%",
		width  : "100%",
		border : `1px solid ${ theme.other.paletteNew.darkModeDarkGrey20 }`,
		...theme.other.rooterAvatars.borderRadius
	},
	svgOneIcon: {
		...theme.other.svgIcons.size30,
		marginLeft: "0.5rem"
	},
	svgIcon: {
		...theme.other.svgIcons.size30
	},
	endedSvgIconRank1: {
		// transform: "scale(0.6)"
		width: "1.4rem"
	},
	endedSvgIcon: {
		// transform: "scale(0.5)"
		width: "1.3rem"
	},
	rankText: {
		textAlign   : "center",
		marginRight : "2rem",
		width       : "20px"
	},
	secondThirdRankText: {
		textAlign   : "center",
		marginRight : "2rem",
		width       : "20px"
	},
	sectionLeft: {
		display    : "flex",
		alignItems : "center"
		// flex       : "1"
	},
	borderStyles: {
		borderBottom : `1px solid ${ theme.other.colors.border.primary }`,
		marginLeft   : "9rem"
	},
	fanRankPoint: {
		fontWeight : "normal !important",
		color      : theme.other.colors.text.primary
	},
	fanRankSelfPoints: {
		fontWeight : "normal !important",
		color      : theme.other.paletteNew.secondaryWhite
	},
	endedFanRank1: {
		background   : "radial-gradient(circle at 19% 50%, #ffc321, #e37a00 34%)",
		borderRadius : "1rem",
		padding      : "0.5rem 1rem",
		marginBottom : "1rem"
	},
	endedFanRank2: {
		background   : "radial-gradient(circle at 12% 50%, #efefef, #9d9d9d 33%)",
		borderRadius : "1rem",
		padding      : "0.5rem 1rem",
		marginBottom : "1rem"
	},
	endedFanRank3: {
		background   : "radial-gradient(circle at 12% 50%, #ff7621, #e33400 34%)",
		borderRadius : "1rem",
		padding      : "0.5rem 1rem",
		marginBottom : "1rem"
	},
	coinsIcon: {
		transform  : "scale(0.9)",
		marginLeft : "0.5rem"
	},
	nameAndScoreContainer: {
		display        : "flex",
		justifyContent : "space-between",
		alignItems     : "center",
		flex           : 1
	},
	ownUserFanRank: {
		color      : theme.other.paletteNew.secondaryWhite,
		fontWeight : "500"
	},
	ownUserName: {
		color      : theme.other.paletteNew.secondaryWhite,
		fontWeight : "500"
	},
	normalUserName: {
		color      : theme.other.colors.text.primary,
		fontWeight : "500"
	}
} ) );
